
<app-bread-crumb></app-bread-crumb>

<app-announcement-info [FunctionID]="this.newsres.FunctionID"></app-announcement-info>

